import { s_r_e as lang } from '~/lang/ru'
import { DispositionName } from './ActConfirm'
import { ServiceRequestDeviceInfo } from './ServiceRequestDeviceInfo'

/** @type { import('vue/types/options').FunctionalComponentOptions<{ act: import('./adapters/act').Act }> } */
export const ActView = {
	functional: true,
	name: 'ActView',
	props: {
		act: Object,
	},
	render(h, { props }) {
		return (
			<div>
				<ServiceRequestDeviceInfo device={ props.act.device } />

				{ props.act.date ? (
					<p class="mb4">
						<b>{ lang('AGREED_DATE') }:</b> { props.act.date }
					</p>
				) : null }

				<p class="mb-4">
					<b>{ lang('ACT_DEFECT') }:</b> { props.act.defect }
				</p>

				<p class="mb-4">
					<b>{ lang('DEFECT_REASON') }:</b> { props.act.defectReason.text }
				</p>

				<p class="mb-4">
					<b>{ lang('CONDITION') }:</b> { props.act.condition.text }
				</p>

				<p class="mb-4">
					<b>{ lang('CONCLUSION_MASTER') }:</b> { props.act.conclusion }
				</p>

				<p class="mb-4">
					<b>{ lang('COMMENT') }:</b> { props.act.comment }
				</p>

				<p class="mb-4">
					<b>{ lang('CONCLUSION_TECHNICAL_CONTROL') }:</b> { props.act.techControl }
				</p>

				{ props.act.disposition ? (
					<p class="mb-0">
						<b>{ DispositionName[props.act.disposition] }</b>
					</p>
				) : null }
			</div>
		)
	}
}
